import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

export const Header = (props) => {
  const { language } = useLanguage();
  const t = translations.header[language] || translations.header.en;

  return (
    <header id="header">
      <div className="container">
        <div className="hero-grid">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="pulse"></span>
              {t.badge}
            </div>
            <h1 className="hero-title">
              {t.title} <span className="gradient">{t.titleHighlight}</span>
            </h1>
            <p className="hero-description">
              {t.description}
            </p>
            <div className="hero-buttons">
              <a href="#contact" className="btn btn-primary page-scroll">
                {t.cta1}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
              <a href="#services" className="btn btn-secondary page-scroll">
                {t.cta2}
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">50+</span>
                <span className="stat-label">{t.stat1Label}</span>
              </div>
              <div className="stat">
                <span className="stat-number">12+</span>
                <span className="stat-label">{t.stat3Label}</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">{t.stat2Label}</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-cards">
              <div className="floating-card card-1">
                <div className="icon">📱</div>
                <span>{language === 'en' ? 'Mobile Apps' : language === 'hi' ? 'मोबाइल ऐप्स' : language === 'pa' ? 'ਮੋਬਾਈਲ ਐਪਸ' : 'Apps Mobiles'}</span>
              </div>
              <div className="floating-card card-2">
                <div className="icon">💻</div>
                <span>{language === 'en' ? 'Web Apps' : language === 'hi' ? 'वेब ऐप्स' : language === 'pa' ? 'ਵੈੱਬ ਐਪਸ' : 'Apps Web'}</span>
              </div>
              <div className="floating-card card-3">
                <div className="icon">⚡</div>
                <span>{language === 'en' ? 'Custom Software' : language === 'hi' ? 'कस्टम सॉफ्टवेयर' : language === 'pa' ? 'ਕਸਟਮ ਸਾਫਟਵੇਅਰ' : 'Logiciel Sur Mesure'}</span>
              </div>
              <div className="floating-card card-4">
                <div className="icon">☁️</div>
                <span>{language === 'en' ? 'Cloud Solutions' : language === 'hi' ? 'क्लाउड सॉल्यूशंस' : language === 'pa' ? 'ਕਲਾਉਡ ਹੱਲ' : 'Solutions Cloud'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
